class ProductForm extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("variant:changed", (e) => {
      const { variant } = e.detail;

      this._updateAtcs(variant);
      this._updateIdInputs(variant);
      this._updateBisButtons(variant);

      if (!variant) return;

      this._updatePrices(variant);
      this._updateUrl(variant);
      this._updateSelectedSizes(variant);
    });
  }

  disconnectedCallback() {}

  get atcs() {
    return this.querySelectorAll("[data-product-form-atc]");
  }

  get bisButtons() {
    return this.querySelectorAll("back-in-stock-button");
  }

  get prices() {
    return this.querySelectorAll("price-snippet");
  }

  get idInputs() {
    return this.querySelectorAll('input[name="id"]');
  }

  get selectedSizes() {
    return document.querySelectorAll("[data-selected-size]");
  }

  get updateUrl() {
    return !this.hasAttribute("disable-update-url");
  }

  get sizeOptionIndex() {
    const index = parseInt(this.getAttribute("size-option-index"), 10);
    if (isFinite(index)) {
      return index;
    }

    return null;
  }

  _updateAtcs(variant) {
    this.atcs.forEach((atc) => {
      atc.disabled = !variant || !variant.available;
    });
  }

  _updateBisButtons(variant) {
    this.bisButtons.forEach((button) =>
      button.setAttribute("selected-variant", variant.id),
    );
  }

  _updatePrices(variant) {
    this.prices.forEach((price) => {
      price.setAttribute("price", variant.price / 100);
      price.setAttribute("compare-at-price", variant.compare_at_price / 100);
      price.setAttribute("currency", window.Shopify.currency.active);
      price.setAttribute("dynamic", "");
    });
  }

  _updateIdInputs(variant) {
    this.idInputs.forEach((idInput) => {
      idInput.value = variant?.id || "";
    });
  }

  _updateSelectedSizes(variant) {
    const sizeOptionIndex = this.sizeOptionIndex;

    if (!sizeOptionIndex) return;

    this.selectedSizes.forEach((selectedSize) => {
      selectedSize.innerHTML = variant.options[sizeOptionIndex];
    });
  }

  _updateUrl(variant) {
    const url = new URL(window.location);

    if (!window.Shopify.designMode && this.updateUrl) {
      url.searchParams.set("variant", variant.id);
      window.history.replaceState("", "", url);
    }
  }
}

if (!customElements.get("product-form")) {
  customElements.define("product-form", ProductForm);
}
